import Styled from './styled'

import { Space, Row, Col, Form, DatePicker } from 'antd'
import { UpOutlined, DownOutlined } from '@ant-design/icons'
import { ExportOutlined } from '@ant-design/icons'
import { useTranslate } from 'hooks/translate'
import moment from 'utils/moment'
import Button from 'components/Button'
import Card from 'components/Card'
import Table from 'components/Table'
import Select from 'components/Select'
import RiskMatrixChart from './components/RiskMatrixChart'
import IncidentTable from '../OperationalLossAndAppetite/components/incidentTable'
import FilterReportStatusSelect from 'components/FilterReportStatusSelect'
import SearchOrganization from 'components/SearchOrganization'
import FilterRiskOwnerSelect from 'components/FilterRiskOwnerSelect'
import FilterReportTypeSelect from 'components/FilterReportTypeSelect'
import Input from 'components/Input'
import { useMemo, useState, useRef } from 'react'
import { useAsync } from 'react-use'
import { useStoreState, useStoreActions } from 'easy-peasy'
import { toPng } from 'html-to-image'
import SignificantGroups from 'components/SignificantGroups'
import _ from 'lodash'
import { useHistory } from 'react-router'
import { incidentReport } from 'services/report'
import { dataURItoBlob } from 'utils/blob'
import { saveAs } from 'file-saver'
import { convertOrganizationalStructureToFilters } from 'utils/organization'
const { RangePicker } = DatePicker
const DATE_FORMAT = 'YYYY-MM-DD'
const PAGINATION_SIZE = 10

const FilterComponent = ({ onChange, onExport }) => {
  const { t } = useTranslate()
  const { riskMatrixFilters } = useStoreState((store) => store.monthlyDashboard)
  return (
    <Form
      layout='horizontal'
      colon={false}
      name='search'
      initialValues={{
        incident_topic: riskMatrixFilters?.incident_topic,
        reporter_company_id: riskMatrixFilters?.reporter_company_id,
        risk_co_company_id: riskMatrixFilters?.risk_co_company_id,
        report_type_id: riskMatrixFilters?.report_type_id,
        risk_owner_org: riskMatrixFilters?.risk_owner_org,
        report_status_id: riskMatrixFilters?.report_status_id,
        date_from: [
          riskMatrixFilters?.date_from
            ? moment(riskMatrixFilters?.date_from)
            : moment().startOf('year'),
          riskMatrixFilters?.date_to ? moment(riskMatrixFilters?.date_to) : moment(),
        ],
      }}
      onFinish={onChange}
    >
      <Row gutter={8}>
        <Col span={22}>
          <Row gutter={8}>
            <Col span={12}>
              <Form.Item labelCol={{ span: 4 }} name='incident_topic' label='Topic'>
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item labelCol={{ span: 4 }} name='reporter_company_id' label='Reporter'>
                <SearchOrganization />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={8}>
            <Col span={12}>
              <Form.Item labelCol={{ span: 4 }} name='risk_co_company_id' label='Risk Co'>
                <SearchOrganization />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item labelCol={{ span: 4 }} name='risk_owner_org' label='Risk Owner'>
                <FilterRiskOwnerSelect />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={8}>
            <Col span={12}>
              <Form.Item
                name='report_type_id'
                labelCol={{ span: 4 }}
                label={t('Report Type')}
                // rules={[
                //   {
                //     required: true,
                //     message: t('Please select report type'),
                //   },
                // ]}
              >
                <FilterReportTypeSelect att={{ mode: 'multiple' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name='date_from' label='Report From - to'>
                <RangePicker allowClear={false} format={DATE_FORMAT} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={8}>
            <Col span={9}>
              <Form.Item name='report_status_id' label={t('Report Status')}>
                <FilterReportStatusSelect att={{ mode: 'multiple' }} />
              </Form.Item>
            </Col>
            <Col span={2}>
              <Button icon={<ExportOutlined />} type='danger' onClick={onExport}>
                {t('Export PDF')}
              </Button>
            </Col>
          </Row>
        </Col>
        <Col span={2}>
          <Button type='primary' htmlType='submit'>
            {t('Search')}
          </Button>
        </Col>
      </Row>
    </Form>
  )
}
const ImpactLevelSelector = ({ value, onChange, disabled }) => {
  const { t } = useTranslate()
  const { impactTypes } = useStoreState((store) => store.filter)
  const options = useMemo(() => {
    return _.map(impactTypes, (item) => {
      return { label: item.name, value: item.id }
    })
  }, [impactTypes])
  return (
    <Select
      disabled={disabled}
      value={value}
      allowClear={false}
      className='impact-select'
      placeholder={t('Select Impact Level')}
      onChange={onChange}
      options={options}
    />
  )
}
const RiskMatrixTable = ({ loading, filters, onChange, dataSource }) => {
  const { t } = useTranslate()
  const history = useHistory()
  const columns = [
    {
      title: t('Report Code'),
      dataIndex: 'reportCodeCd',
      key: 'reportCodeCd',
      className: 'bold',
    },
    {
      title: t('Incident Topic'),
      dataIndex: 'incidentTopic',
      key: 'incidentTopic',
      className: 'bold',
    },
  ]
  const total = useMemo(() => {
    return dataSource?.total || 0
  }, [dataSource])
  return (
    <Styled className='incident-bar-component'>
      <Table
        pagination={{
          current: filters.page,
          pageSize: filters.size,
          total,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: (total) => t('Total ${total} items', { total }),
        }}
        columns={columns}
        loading={loading}
        dataSource={dataSource?.items}
        onChange={onChange}
        onRow={(record) => {
          return {
            onClick: () => {
              const href = history.createHref({
                pathname: `incident-report/${record.reportTypeId}/${record.reportHeaderId}`,
              })
              window.open(href, '_blank')
            },
          }
        }}
      ></Table>
    </Styled>
  )
}
export default function RiskMatrix () {
  const { t } = useTranslate()
  const [status, setStatus] = useState('all')
  const [impactTypeId, setImpactTypeId] = useState('')
  const [dataSource, setDataSource] = useState([])
  const [showHeader, setShowHeader] = useState(true)

  const {
    loading,
    riskMatrixList,
    riskMatrixSelectedList,
    riskMatrixChartData,
    riskMatrixFilters,
    riskMatrixChartFilters,
  } = useStoreState((store) => store.monthlyDashboard)
  const {
    getRiskMatrixListThunk,
    getRiskMatrixSelectedListValueThunk,
    setRiskMatrixSelectedList,
    setRiskMatrixFilters,
    setRiskMatrixChartFilters,
    getReportMatrixValueThunk,
  } = useStoreActions((store) => store.monthlyDashboard)
  const handleSubmit = (event) => {
    const [date_from, date_to] = event.date_from
    setRiskMatrixFilters({
      ...riskMatrixFilters,
      ...event,
      date_from: date_from?.format(DATE_FORMAT),
      date_to: date_to?.format(DATE_FORMAT),
    })
  }
  const handleExport = async () => {
    const svg = document.getElementById('risk-chart')
    let dataURI = null
    if (!_.isEmpty(svg)) {
      dataURI = await toPng(svg, { backgroundColor: '#ffffff' })
    }
    //TODO: ADD EXPORT LOGIC HERE
    if (dataURI !== null) {
      const blob = dataURItoBlob(dataURI)
      const { data } = await incidentReport(riskMatrixFilters, blob)
      if (data) {
        saveAs(data.file, data.filename)
      }
    }
  }
  const clearList = () => {
    setRiskMatrixSelectedList({
      items: [],
    })
  }
  const firstUpdate = useRef(true)
  useAsync(async () => {
    if (firstUpdate.current) {
      firstUpdate.current = false
      return
    }
    // const risk_owner_company_id = convertOrganizationalStructureToFilters(riskMatrixFilters.risk_owner)
    // const filter = {
    //   ...riskMatrixFilters,
    //   risk_owner_company_id: risk_owner_company_id?.company_id || [] ,
    //   risk_owner: ''
    // }
    getRiskMatrixListThunk(riskMatrixFilters)
    getRiskMatrixSelectedListValueThunk()
  }, [riskMatrixFilters])

  useAsync(async () => {
    if (firstUpdate.current) {
      firstUpdate.current = false
      return
    }
    const dataSource = riskMatrixChartData.find(
      (item) => item.impact_type_id === riskMatrixChartFilters?.impact_type_id
    )
    setDataSource(dataSource.data[status] || [])
    if (impactTypeId) {
      getRiskMatrixSelectedListValueThunk()
    }
  }, [riskMatrixChartFilters, riskMatrixFilters])
  useAsync(async () => {
    const dataSource = riskMatrixChartData.find((item) => item.impact_type_id === impactTypeId)
    setDataSource(dataSource.data[status] || [])
  }, [riskMatrixChartData])

  useAsync(async () => {
    setStatus(
      riskMatrixChartFilters.is_significant === undefined
        ? 'all'
        : riskMatrixChartFilters.is_significant
        ? 'significant'
        : 'insignificant'
    )
    setImpactTypeId(riskMatrixChartFilters?.impact_type_id)
  }, [])
  return (
    <Styled className='risk-matrix-component'>
      <Space size='middle' direction='vertical' style={{ width: '100%' }}>
        {showHeader ? <FilterComponent onChange={handleSubmit} onExport={handleExport} /> : null}
        <Row justify='end'>
          <Col>
            <Button
              onClick={() => setShowHeader(!showHeader)}
              icon={showHeader ? <UpOutlined /> : <DownOutlined />}
              type='link'
            >
              {showHeader ? 'Hide Filter' : 'Show Filter'}
            </Button>
          </Col>
        </Row>
        <Card
          title={t('Risk Matrix Dashboard')}
          titleExtra={
            <>
              <ImpactLevelSelector
                disabled={true}
                value={impactTypeId}
                onChange={(e) => {
                  setImpactTypeId(e)
                  setRiskMatrixChartFilters({
                    ...riskMatrixChartFilters,
                    risk_level_id: '',
                    impact_type_id: e,
                  })
                  getReportMatrixValueThunk(e)
                  clearList()
                }}
              />
            </>
          }
          extra={
            <>
              <SignificantGroups
                value={status}
                onChange={(value) => {
                  setStatus(value)
                  setRiskMatrixChartFilters({
                    ...riskMatrixChartFilters,
                    is_significant:
                      value === 'significant'
                        ? true
                        : value === 'insignificant'
                        ? false
                        : undefined,
                  })
                }}
              />
            </>
          }
        >
          <Row gutter={8}>
            <Col span={16}>
              <RiskMatrixChart
                dataSource={dataSource}
                loading={loading}
                impactTypeId={impactTypeId}
                defaultValue={riskMatrixChartFilters?.risk_level_id}
                onChange={(e) => {
                  if (!e) {
                    clearList()
                  }

                  setRiskMatrixChartFilters({
                    ...riskMatrixChartFilters,
                    risk_level_id: e,
                    page: 1,
                    size: PAGINATION_SIZE,
                  })
                }}
              />
            </Col>
            <Col span={8}>
              <Card title={t('Incident Reports')}>
                <RiskMatrixTable
                  loading={loading}
                  dataSource={riskMatrixSelectedList}
                  filters={riskMatrixChartFilters}
                  onChange={(pagination) => {
                    setRiskMatrixChartFilters({
                      ...riskMatrixChartFilters,
                      page: pagination.current,
                      size: pagination.pageSize,
                    })
                  }}
                ></RiskMatrixTable>
              </Card>
            </Col>
          </Row>
        </Card>
        <Card title={t('Incident Report')}>
          <IncidentTable
            loading={loading}
            dataSource={riskMatrixList}
            filters={riskMatrixFilters}
            onChange={(pagination) => {
              setRiskMatrixFilters({
                ...riskMatrixFilters,
                page: pagination.current,
                size: pagination.pageSize,
              })
            }}
          />
        </Card>
      </Space>
    </Styled>
  )
}
